export default "/_next/static/images/checkmark-white-cab643cb20b6a8b01dabd3828b057848.svg";